import { ModuleWithProviders, NgModule } from '@angular/core';
import { PmsComponent } from './pms.component';
import { CatalogComponent } from './catalog/catalog.component';
import { CategoriesComponent } from './categories/categories.component';
import { PmsRoutingModule } from './pms-routing.module';
import { CommonModule } from '@angular/common';
import { ProductsComponent } from './products/products.component';
import { ConfigurationsComponent } from './configurations/configurations.component';
import { FeaturesComponent } from './features/features.component';
import { ImageManagementComponent } from './image-management/image-management.component';
import { StoresComponent } from './stores/stores.component';
import { ShippingComponent } from './shipping/shipping.component';
import { PmsHomeComponent } from './pms-home/pms-home.component';
import { NbActionsModule, NbCardModule, NbIconModule, NbLayoutModule } from '@nebular/theme';
import { GridsterModule } from 'angular-gridster2';
import { WidgetComponent } from './pms-home/widget/widget.component';
import { StoreManagementWidgetComponent } from './pms-home/widget/store-management-widget/store-management-widget.component';
import { CatalogueWidgetComponent } from './pms-home/widget/catalogue-widget/catalogue-widget.component';
import { CategoriesWidgetComponent } from './pms-home/widget/categories-widget/categories-widget.component';
import { ProductsWidgetComponent } from './pms-home/widget/products-widget/products-widget.component';
import { ShippingWidgetComponent } from './pms-home/widget/shipping-widget/shipping-widget.component';
import { PromotionsWidgetComponent } from './pms-home/widget/promotions-widget/promotions-widget.component';
import { PricingWidgetComponent } from './pms-home/widget/pricing-widget/pricing-widget.component';
import { ConfigsWidgetComponent } from './pms-home/widget/configs-widget/configs-widget.component';
import { ReviewsWidgetComponent } from './pms-home/widget/reviews-widget/reviews-widget.component';
import { FeaturesWidgetComponent } from './pms-home/widget/features-widget/features-widget.component';
import { RenderWidgetDirective } from './pms-home/widget/render-widget.directive';
import { Angular2SmartTableModule } from 'angular2-smart-table';
import { OfbizFormsModule } from '@urbannex/ofbiz-forms';
import { StoresModule } from './stores/stores.module';
import { ProductsModule } from './products/products.module';
import { CatalogModule } from './catalog/catalog.module';
import { CategoriesModule } from './categories/categories.module';
import { ConfigurationsModule } from './configurations/configurations.module';
import { FeaturesModule } from './features/features.module';
import { ImageManagementModule } from './image-management/image-management.module';
import { ShippingModule } from './shipping/shipping.module';
import { FacilitiesComponent } from './facilities/facilities.component';
import { OrdersModule } from './orders/orders.module';
import { FacilitiesModule } from './facilities/facilities.module';
import { MarketingModule } from './marketing/marketing.module';


@NgModule({
  declarations: [PmsComponent, PmsHomeComponent, WidgetComponent, StoreManagementWidgetComponent, CatalogueWidgetComponent, CategoriesWidgetComponent, ProductsWidgetComponent, ShippingWidgetComponent, PromotionsWidgetComponent, PricingWidgetComponent, ConfigsWidgetComponent, ReviewsWidgetComponent, FeaturesWidgetComponent, RenderWidgetDirective, FacilitiesComponent],
  imports: [
    CommonModule,
    PmsRoutingModule,
    NbLayoutModule,
    NbCardModule,
    NbIconModule,
    NbActionsModule,
    Angular2SmartTableModule,
    GridsterModule,
    StoresModule,
    ProductsModule,
    CatalogModule,
    CategoriesModule,
    ConfigurationsModule,
    FeaturesModule,
    ImageManagementModule,
    ShippingModule,
    OrdersModule,
    FacilitiesModule,
    MarketingModule,
    OfbizFormsModule.forRoot("https://kwikstore-dev:8443/rest/")
  ],
  exports: [
    PmsComponent,
    PmsHomeComponent,
    StoreManagementWidgetComponent,
    CatalogueWidgetComponent,
    CategoriesWidgetComponent,
    ProductsWidgetComponent,
    ShippingWidgetComponent,
    PromotionsWidgetComponent,
    PricingWidgetComponent,
    ConfigsWidgetComponent,
    ReviewsWidgetComponent,
    FeaturesWidgetComponent,
    RenderWidgetDirective,
    StoresModule,
    ProductsModule,
    CatalogModule,
    ConfigurationsModule,
    FeaturesModule,
    ImageManagementModule,
    ShippingModule,
    OrdersModule,
    FacilitiesModule
  ]
})
export class PmsModule { 
  public static forRoot():ModuleWithProviders<PmsModule> {
    return {
      ngModule: PmsModule,
    };
  }
}
